// ===================================================================
// KAIXO - CRMActivity
// ===================================================================
// Vista 'activity' del CRM: log de acciones recientes (asignaciones,
// cambios de estado, citas...) con filtros por agente, estado, idioma,
// país, región.
// ===================================================================

import React from 'react';
import ct from './i18n';

export default function CRMActivity({
    activities,
    agents,
    filters,
    onFilterChange,
    onLoad
}) {
    return (
        <>
            {/* Filtros */}
            <div className="crm-activity-filters">
                <select
                    value={filters.agentId}
                    onChange={e => {
                        const f = { ...filters, agentId: e.target.value };
                        onFilterChange(f);
                        onLoad(f);
                    }}
                >
                    <option value="">{ct.all} · Agentes</option>
                    {agents.map(a => (
                        <option key={a._id} value={a.user?._id || a.user}>
                            {a.user?.name || '—'}
                        </option>
                    ))}
                </select>
                <select
                    value={filters.status}
                    onChange={e => {
                        const f = { ...filters, status: e.target.value };
                        onFilterChange(f);
                        onLoad(f);
                    }}
                >
                    <option value="">{ct.all} · {ct.status}</option>
                    {Object.entries(ct.statuses || {}).map(([k, v]) => (
                        <option key={k} value={k}>{v}</option>
                    ))}
                </select>
                <input
                    placeholder="Idioma"
                    value={filters.language}
                    onChange={e => onFilterChange({ ...filters, language: e.target.value })}
                    onBlur={() => onLoad()}
                />
                <input
                    placeholder="País"
                    value={filters.country}
                    onChange={e => onFilterChange({ ...filters, country: e.target.value })}
                    onBlur={() => onLoad()}
                />
                <input
                    placeholder="Región"
                    value={filters.region}
                    onChange={e => onFilterChange({ ...filters, region: e.target.value })}
                    onBlur={() => onLoad()}
                />
            </div>

            {activities.length === 0 ? (
                <p className="crm-center crm-dim">{ct.noActivity}</p>
            ) : (
                activities.map(a => (
                    <div key={a._id} className="crm-activity-item">
                        <div className="crm-act-dot" />
                        <div className="crm-act-content">
                            <span className="crm-act-desc">
                                {a.agent?.name && <strong>{a.agent.name} · </strong>}
                                {a.description || a.type}
                            </span>
                            {a.lead && (
                                <span className="crm-act-lead">
                                    {a.lead.firstName} {a.lead.lastName}
                                </span>
                            )}
                            <span className="crm-act-time">
                                {new Date(a.createdAt).toLocaleString()}
                            </span>
                        </div>
                    </div>
                ))
            )}
        </>
    );
}
